import React from 'react'
import URL from 'url-parse'
import pick from 'lodash/pick'

class PixelPing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      'imgURL': null
    }
  }

  componentDidMount() {
    if (typeof window != 'undefined') {
      // Wait a second. Terribly hacky but works fine.
      setTimeout(() => {
        var separator = "|pixel-ping-break|";

        var loc = new URL(window.location.href, true)
        loc.query = pick(loc.query, ['parentUrl', 'parentTitle'])

        var titleEl = document.getElementsByTagName("title").item(0);
        var key = encodeURIComponent("[EMBED: " + titleEl.text + "] " + loc.query.parentTitle + separator) + loc.query.parentUrl;

        if (loc.query.parentUrl && !loc.query.parentUrl.includes('propublica.org')) {
          if (loc.host == 'projects.propublica.org') {
            this.setState({'imgURL': "https://pixel.propublica.org/pixel.gif?key=" + key})
          } else {
            console.log('💥 Pixel Ping debugging')
            console.log('👁️ Encoded:', key, '\n👀 Decoded:', decodeURIComponent(key))
          }
        }
      }, 1000)
    }
  }

  render() {
    return <img className="pixel-ping" height={1} width={1} src={this.state.imgURL} />
  }
}

export default PixelPing



// WEBPACK FOOTER //
// ./src/components/analytics/PixelPing/index.js